"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PageLevelMessageProps_1 = require("./PageLevelMessageProps");
var PageLevelMessageState_1 = require("./PageLevelMessageState");
/** Platform UI Components */
var Alert_1 = require("@idp/duc/components/atoms/Alert");
/** Stylesheets */
var styles = require("./PageLevelMessage.scss");
/** LOB Components */
/** Api, Reporting, Mappers, Request, Response */
var PageLevelMessage = /** @class */ (function (_super) {
    __extends(PageLevelMessage, _super);
    function PageLevelMessage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new PageLevelMessageState_1.default();
        return _this;
    }
    PageLevelMessage.prototype.componentDidMount = function () {
        setTimeout(function () {
            document.getElementById('alert-msg').focus();
        }, 1000);
    };
    PageLevelMessage.prototype.messageType = function () {
        if (this.props.data.type === PageLevelMessageProps_1.PageLevelMessageType.SUCCESS) {
            return 'success';
        }
        else if (this.props.data.type === PageLevelMessageProps_1.PageLevelMessageType.WARNING) {
            return 'warning';
        }
        else if (this.props.data.type === PageLevelMessageProps_1.PageLevelMessageType.ERROR) {
            return 'error';
        }
        else if (this.props.data.type === PageLevelMessageProps_1.PageLevelMessageType.INFO) {
            return 'info';
        }
    };
    PageLevelMessage.prototype.closeButton = function () {
        if ((this.props.options) && (this.props.options.closeButton === true)) {
            return true;
        }
        else {
            return false;
        }
    };
    PageLevelMessage.prototype.renderChildren = function () {
        if (this.props.children) {
            return (React.createElement(React.Fragment, null, this.props.children));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.data.messageText } })));
    };
    PageLevelMessage.prototype.render = function () {
        return (React.createElement("div", { id: "alert-msg", tabIndex: 0, className: [styles.loginAlertWrapper].join(' '), "data-test-id": this.props.testId },
            React.createElement(Alert_1.default, { className: [styles.alert].join(' '), type: this.messageType(), closeable: this.closeButton() }, this.renderChildren())));
    };
    return PageLevelMessage;
}(React.Component));
exports.default = PageLevelMessage;
//# sourceMappingURL=PageLevelMessage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelMessage/PageLevelMessage.js
// module id = 1667
// module chunks = 8